module.exports = {"131024100":"淑阳镇","131024101":"蒋辛屯镇","131024102":"渠口镇","131024103":"安头屯镇","131024104":"安平镇","131024105":"刘宋镇","131024106":"五百户镇","131024107":"钱旺镇","131024108":"钳屯镇","131024500":"河北香河经济开发区","131024501":"香河新兴产业示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131024.json
// module id = 323
// module chunks = 0